export const transactionHistory = `<p><strong>Navigation</strong>: Accounts / Transaction History</p>
<p><img src='${process.env.PUBLIC_URL}/images/3/7/1.png' /></p>
<p>On this page you can view, print and export the transaction history for an account. The page will display transactions by Date, Type, Description, Debit, Credit and Balance.&nbsp;</p>
<p>You must have the appropriate entitlements to be able to view transaction history for an account.</p>
<p>For options to manage the columns displayed, and to print or export account data, select the three-dot symbol on the top right of the page.</p>
<p>The following fields are available to view and export :</p>
<table class='table table-bordered' >
<tbody>
<tr>
<td colspan="3" nowrap="nowrap" width="643">
<p align="center"><strong>Transaction History List Fields (Real accounts and in account by virtual structure)</strong></p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p><strong>Column</strong></p>
</td>
<td nowrap="nowrap" width="96">
<p align="center"><strong>Default View</strong></p>
</td>
<td width="367">
<p><strong>Rationale</strong></p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Date</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>Posting date</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Type</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>Type of transaction</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Reference number</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Debit amount</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Debit Currency</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Credit amount</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Credit currency</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>This field is only viewable in format CSV consolidated</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Balance</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Bank country</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>Beneficiary bank country&nbsp; for Debits&nbsp; and Sender bank country&nbsp; for Credits</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Name</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>Beneficiary name for Debits&nbsp; and Sender name for Credits</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Sort code</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>Beneficiary sort code for Debits&nbsp; and Sender sort code for Credits</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Account number</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>Beneficiary account number for Debits&nbsp; and Sender account number for Credits</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>SWIFT BIC</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>Beneficiary SWIFT BIC for Debits&nbsp; and Sender SWIFT BIC for Credits - where populated</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>IBAN</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>Beneficiary IBAN for Debits&nbsp; and Sender IBAN for Credits - Where populated</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Virtual account name</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>This field will only be populated for postings on a virtual structure and where the payment has been debited or credited to a NEAVA or EAVA. Any payments routed to a suspense account would not be populated.</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Virtual account number</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>This field will only be populated for postings on a virtual structure and where the payment has been debited or credited to a NEAVA or EAVA. Any payments routed to a suspense account would not be populated.</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Bank to Bank reference</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>Bank to bank reference</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Payment reference</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>Payment reference</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Payment reference - PMI</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Payment reference - EEI</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Payment reference - INI</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Payment reference - CRF</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Payment reference - OAS</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>Previously only one line of unstructured reference was displayed in transaction history.&nbsp; However, up to 4 full lines will be displayed if available</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Payment reference – OAS 2</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">&nbsp;</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Payment reference – OAS 3</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">&nbsp;</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Payment reference – OAS 4</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">&nbsp;</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Payment reference - TXI</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">No</p>
</td>
<td width="367">
<p>&nbsp;</p>
</td>
</tr>
<tr>
<td nowrap="nowrap" width="180">
<p>Interest source</p>
</td>
<td nowrap="nowrap" width="96">
<p align="center">Yes</p>
</td>
<td width="367">
<p>This field will be populated with details of where the interest was earned, if the interest relates to an interest redirection from another account</p>
</td>
</tr>
</tbody>
</table>
`



// WEBPACK FOOTER //
// ./src/components/content/accounts/transactionHistory.ts